<p-message class="block mb-4" icon="pi pi-times-circle" severity="error">
  <ng-content/>
</p-message>
